import { Typography } from 'antd';
import classes from './IndexCard.module.scss';

type IndexCardProps = {
  index: string | number;
};

export const IndexCard = ({ index }: IndexCardProps) => {
  return (
    <Typography.Text type="secondary" className={classes.indexesItem}>
      #{index}
    </Typography.Text>
  );
};
